import { useEffect } from 'react'
import {
  SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT,
  SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT,
} from 'shared/constants'
import { useFeature } from 'flagged'
import BirthdayWishlistModal from './BirthdayWishlistModal'
import { Responses } from '../../global'

const BIRTHDAY_WISHLIST_MODAL_LOCAL_STORAGE_KEY =
  'birthdayWishlistModalNotificationDismissed'

export const useDisplayBirthdayWishlistModal = (
  registry: Responses.Registry,
  eventLocation: string
) => {
  const isBirthdayWishlistModalEnabled = useFeature(
    'show_birthday_list_feature_modal'
  )

  useEffect(() => {
    if (isBirthdayWishlistModalEnabled) {
      displayBirthdayWishlistModal(registry, eventLocation)
    }
  }, [isBirthdayWishlistModalEnabled])
}

export const displayBirthdayWishlistModal = (
  registry: Responses.Registry,
  eventLocation: string
) => {
  if (!window) return
  if (!window.currentUser) return

  // Only show once per user
  const isDismissed = localStorage.getItem(
    BIRTHDAY_WISHLIST_MODAL_LOCAL_STORAGE_KEY
  )
  if (isDismissed) return

  // Only show for user accounts that are at least 7 days old
  const userCreatedAt = new Date(window.currentUser.createdAt)
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  if (userCreatedAt > sevenDaysAgo) return

  // Only show if user has registries
  if (window.currentUser.registries?.length < 1) return

  // Delay opening of modal for 5 seconds
  setTimeout(() => {
    PubSub.publish(SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT, {
      renderContent: (cm: () => void) => (
        <BirthdayWishlistModal
          closeModal={cm}
          eventLocation={eventLocation}
          registry={registry}
        />
      ),
      onModalOpen: () =>
        localStorage.setItem(BIRTHDAY_WISHLIST_MODAL_LOCAL_STORAGE_KEY, 'true'),
    })
    PubSub.publish(SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT)
  }, 5_000)
}
